var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkipUploadDesign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 183,
    viewBox: "0 0 301 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2802_78361)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 182,
    transform: "translate(0.5 0.544678)",
    fill: "#F9F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.786 190.1C218.859 184.452 226.208 175.56 232.068 164.122C235.183 158.14 236.92 151.539 237.151 144.8C237.35 138.422 236.07 132.084 233.412 126.282C215.062 86.3 171.738 121.334 184.862 89.769C197.986 58.2039 164.257 45.3945 150.989 57.6792C137.721 69.9638 143.309 73.7872 102.559 77.508C84.2254 79.1835 76.6601 88.0478 75.1485 95.5995C63.4288 97.9611 37.5467 102.19 33.3626 112.08C12.9841 160.25 76.2948 154.034 58.3641 172.683",
    stroke: "#D2D2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.179 68.0524C244.18 67.9932 244.181 67.934 244.181 67.8746C244.18 65.0431 242.623 62.4128 240.062 60.9189C237.502 59.425 234.302 59.2795 231.6 60.534C227.241 54.5655 219.368 51.8031 211.912 53.6261C204.455 55.4491 199.015 61.4664 198.306 68.6739C191.532 70.8012 186.964 76.7596 186.964 83.47V83.47C186.964 92.0831 194.396 99.0654 203.565 99.0654H241.665C250.833 99.0654 258.266 92.0831 258.266 83.47V83.47C258.265 75.7685 252.282 69.22 244.179 68.0524Z",
    fill: "url(#paint0_linear_2802_78361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.599 60.5341C228.191 55.8608 222.547 53.0687 216.517 53.0723",
    stroke: "#273754",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.183 67.8748C244.183 65.7031 243.265 63.6204 241.63 62.0847C239.996 60.5491 237.779 59.6864 235.467 59.6864",
    stroke: "#273754",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.563 99.0655H241.664C250.832 99.0655 258.265 92.0832 258.265 83.4701",
    stroke: "#273754",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.426,
    y: 110.293,
    width: 17.645,
    height: 16.5764,
    transform: "rotate(180 231.426 110.293)",
    fill: "#EE4360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.265 94.9663L222.605 82.1332L208.944 94.9663H236.265Z",
    fill: "#EE4360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.673 205.962C205.605 207.863 204.022 209.45 202.093 210.557C200.163 211.663 197.959 212.246 195.712 212.245H119.383V202.866H133.138L152.278 160.991C153.282 158.795 154.928 156.926 157.016 155.614C159.105 154.301 161.545 153.601 164.039 153.599H212.652C222.135 153.599 228.354 163.136 224.233 171.342L206.673 205.962Z",
    fill: "#2E3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.352 142.453V133.484C135.352 129.983 136.069 126.517 137.462 123.283C138.855 120.048 140.896 117.11 143.47 114.634C146.044 112.159 149.099 110.195 152.462 108.856C155.824 107.516 159.428 106.827 163.068 106.827H206.324C213.378 106.826 220.262 108.913 226.039 112.805C231.817 116.696 236.21 122.204 238.62 128.58L248.811 155.521C252.182 164.438 249.463 173.615 243.255 179.606C237.354 185.302 228.564 187.22 220.594 184.787L207.3 178.963L202.637 185.548L135.352 142.453Z",
    fill: "#D6DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.836 155.453H116.549L107.004 126.522C106.86 126.084 106.824 125.619 106.902 125.165C106.979 124.711 107.166 124.281 107.449 123.91C107.731 123.539 108.101 123.237 108.527 123.03C108.954 122.822 109.425 122.713 109.903 122.714H151.372C152.435 122.713 153.469 123.039 154.327 123.642C155.184 124.245 155.82 125.096 156.141 126.069L165.836 155.453Z",
    fill: "#2E3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0486 124.067C99.0486 121.89 99.9475 119.803 101.548 118.264C103.148 116.725 105.318 115.86 107.581 115.86",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2513 124.067C93.2538 120.412 94.765 116.909 97.4525 114.326C100.14 111.743 103.784 110.293 107.583 110.293",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7515 124.067C87.7515 119.008 89.8409 114.156 93.56 110.579C97.2792 107.002 102.324 104.992 107.583 104.992",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.711 180.995C235.742 188.995 220.232 185.801 215.876 184.1C203.707 179.331 187.823 166.381 184.357 164.36C183.816 163.953 183.154 163.721 182.467 163.697C181.779 163.674 181.102 163.86 180.532 164.229L172.05 170.75C169.855 172.238 167.653 172.316 165.623 170.624L154.672 161.721L152.352 162.905C151.163 163.533 149.764 163.685 148.46 163.326C148.075 163.204 147.735 162.98 147.479 162.678C147.222 162.377 147.06 162.012 147.012 161.625C146.964 161.239 147.031 160.847 147.205 160.496C147.38 160.145 147.655 159.849 147.998 159.642L165.847 148.83C170.478 145.914 175.893 144.36 181.429 144.359H182.582C185.704 144.359 188.82 144.649 191.884 145.226L228.527 153.61C240.175 155.453 254.619 167.325 242.711 180.995Z",
    fill: "#C9A2A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.815 161.758L163.559 156.648",
    stroke: "#2E3860",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.229 164.977L167.544 160.184",
    stroke: "#2E3860",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.481 168.55L171.799 163.754",
    stroke: "#2E3860",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.635 185.552L198.265 190.332C192.315 196.842 184.196 201.158 175.299 202.54C166.403 203.921 157.284 202.281 149.507 197.902L108.063 174.569C107.307 174.144 106.42 173.987 105.556 174.125C104.692 174.263 103.906 174.688 103.333 175.326L59.4289 224.244L45.4291 213.57C44.1169 212.562 43.1463 211.202 42.6411 209.661L41.0569 204.822C40.2204 202.269 38.6153 200.012 36.4448 198.337L32.2524 195.114L85.9181 139.1C90.5709 134.199 96.8942 131.061 103.744 130.256C110.593 129.45 117.516 131.03 123.259 134.708L202.635 185.552Z",
    fill: "white",
    stroke: "#2E3860",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.16 202.972L123.425 202.892C122.893 202.891 122.365 202.99 121.872 203.186C121.38 203.381 120.932 203.667 120.555 204.029C120.177 204.391 119.878 204.821 119.674 205.294C119.47 205.767 119.365 206.275 119.365 206.787V255.44H101.564C99.8847 255.439 98.2432 254.958 96.8486 254.058L92.4672 251.232C90.1546 249.739 87.4326 248.942 84.6475 248.941H79.2814C79.3344 248.384 79.3644 247.832 79.3644 247.253V190.496C79.3644 176.268 95.4212 167.41 108.19 174.594L160.16 202.972Z",
    fill: "white",
    stroke: "#2E3860",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 116.21L195.703 106.404L189.748 95.3206L178.224 98.7896V116.21Z",
    fill: "#C9A2A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 98.8961V116.21L195.703 106.404",
    stroke: "#2E3860",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 106.548L186.494 101.631C187.489 101.039 188.309 100.213 188.879 99.2303C189.448 98.2479 189.747 97.142 189.748 96.0173V95.3206L178.224 98.7896V106.548Z",
    fill: "#2E3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.543 92.2181V93.0867C195.543 94.0313 195.153 94.9372 194.459 95.6053C193.765 96.2734 192.823 96.6492 191.841 96.6499H189.296L188.792 97.5936C188.151 98.8 187.194 99.8253 186.016 100.568C184.839 101.312 183.48 101.747 182.074 101.832L177.168 102.1C176.682 102.129 176.194 102.062 175.736 101.903C175.278 101.744 174.858 101.496 174.503 101.175C174.148 100.854 173.866 100.467 173.672 100.037C173.479 99.6064 173.379 99.1427 173.38 98.6741V88.1241C173.38 86.5697 174.022 85.079 175.164 83.9799C176.307 82.8808 177.857 82.2633 179.473 82.2633H181.332C182.709 82.2632 184.046 82.712 185.124 83.5363C186.201 84.3607 186.957 85.5119 187.267 86.8023L188.028 89.9633C188.3 89.5618 188.672 89.2318 189.11 89.0029C189.548 88.774 190.038 88.6535 190.537 88.6523H191.83C192.318 88.6512 192.801 88.7427 193.251 88.9214C193.702 89.1002 194.111 89.3627 194.456 89.694C194.801 90.0252 195.075 90.4187 195.261 90.8518C195.448 91.285 195.544 91.7493 195.543 92.2181Z",
    fill: "#C9A2A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.689 88.3601H176.92L176.248 94.7491H178.272",
    stroke: "#2E3860",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.658 88.3546L184.65 88.6603",
    stroke: "#2E3860",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.992 91.0089C191.381 91.0089 190.794 91.2425 190.362 91.6583C189.93 92.0741 189.687 92.6381 189.687 93.2262",
    stroke: "#2E3860",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.054 92.6524C182.413 92.6524 182.704 92.1555 182.704 91.5425C182.704 90.9294 182.413 90.4325 182.054 90.4325C181.696 90.4325 181.405 90.9294 181.405 91.5425C181.405 92.1555 181.696 92.6524 182.054 92.6524Z",
    fill: "#2E3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.235 92.6524C174.594 92.6524 174.885 92.1555 174.885 91.5425C174.885 90.9294 174.594 90.4325 174.235 90.4325C173.877 90.4325 173.586 90.9294 173.586 91.5425C173.586 92.1555 173.877 92.6524 174.235 92.6524Z",
    fill: "#2E3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.942 97.5936H178.47C179.159 97.5939 179.824 97.3517 180.34 96.9126",
    stroke: "#2E3860",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.143 85.7696C194.145 86.8783 193.738 87.9522 192.994 88.8031C192.677 88.7208 192.35 88.6792 192.022 88.6794H190.713C190.209 88.6807 189.714 88.8016 189.271 89.0311C188.829 89.2607 188.453 89.5917 188.178 89.9945L187.409 86.8238C187.207 85.9845 186.813 85.1983 186.255 84.5218C185.719 85.1436 185.012 85.6094 184.213 85.8664C183.702 86.0347 183.165 86.1202 182.625 86.1193C181.615 86.1258 180.628 85.8253 179.809 85.2614C179.326 84.9366 178.921 84.5177 178.621 84.0323C178.32 83.5469 178.131 83.0061 178.066 82.4457C176.918 82.7135 175.876 83.2907 175.063 84.1084C174.249 84.9261 173.699 85.9499 173.478 87.0578C172.819 86.7636 172.235 86.3346 171.768 85.8011C171.301 85.2677 170.962 84.6428 170.776 83.9706C170.59 83.2984 170.561 82.5954 170.691 81.9113C170.821 81.2272 171.106 80.5786 171.527 80.0115C171.948 79.4444 172.495 78.9725 173.128 78.6293C173.761 78.2861 174.465 78.0799 175.191 78.0253C175.917 77.9707 176.647 78.069 177.328 78.3133C178.01 78.5576 178.627 78.942 179.136 79.4391C179.581 78.9836 180.12 78.6215 180.719 78.3756C181.318 78.1298 181.964 78.0057 182.616 78.0111C184.906 78.0111 186.801 79.501 187.136 81.4453C187.776 81.1689 188.47 81.0268 189.172 81.0285C190.489 81.0285 191.753 81.5278 192.685 82.4168C193.617 83.3058 194.141 84.5117 194.143 85.7696Z",
    fill: "#2E3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.747 119.964C110.944 119.964 128.128 102.782 128.128 81.5881C128.128 60.3939 110.944 43.2126 89.747 43.2126C68.5496 43.2126 51.3657 60.3939 51.3657 81.5881C51.3657 102.782 68.5496 119.964 89.747 119.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.756 116.971C106.953 116.971 124.137 99.7893 124.137 78.5952C124.137 57.401 106.953 40.2197 85.756 40.2197C64.5585 40.2197 47.3746 57.401 47.3746 78.5952C47.3746 99.7893 64.5585 116.971 85.756 116.971Z",
    stroke: "#2E3860",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.756 50.4975C87.0344 50.4975 88.0708 49.4613 88.0708 48.183C88.0708 46.9048 87.0344 45.8685 85.756 45.8685C84.4775 45.8685 83.441 46.9048 83.441 48.183C83.441 49.4613 84.4775 50.4975 85.756 50.4975Z",
    fill: "#EE4360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.756 111.322C87.0344 111.322 88.0708 110.286 88.0708 109.007C88.0708 107.729 87.0344 106.693 85.756 106.693C84.4775 106.693 83.441 107.729 83.441 109.007C83.441 110.286 84.4775 111.322 85.756 111.322Z",
    fill: "#EE4360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3391 80.9096C56.6176 80.9096 57.654 79.8734 57.654 78.5952C57.654 77.3169 56.6176 76.2806 55.3391 76.2806C54.0607 76.2806 53.0243 77.3169 53.0243 78.5952C53.0243 79.8734 54.0607 80.9096 55.3391 80.9096Z",
    fill: "#EE4360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.177 80.9096C117.456 80.9096 118.492 79.8734 118.492 78.5952C118.492 77.3169 117.456 76.2806 116.177 76.2806C114.899 76.2806 113.862 77.3169 113.862 78.5952C113.862 79.8734 114.899 80.9096 116.177 80.9096Z",
    fill: "#EE4360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9733 68.5745L85.6672 79.646L98.9621 57.7247",
    stroke: "#2E3860",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2802_78361",
    x1: 222.615,
    y1: 53.0712,
    x2: 222.615,
    y2: 99.0654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2802_78361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 182,
    fill: "white",
    transform: "translate(0.5 0.544678)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipUploadDesign);
export default __webpack_public_path__ + "static/media/skip-upload-design.22fd5fb1853656da79960fa25866b040.svg";
export { ForwardRef as ReactComponent };